/**
 * lang.js
 */

const BASEURI = '/common';

// 配置网站支持的语言
const langs = {
    en: 'en',
    'zh-cn': 'zh-CN'
}

// en cn 106 63
const languages = {
    en: 'en',
    'zh-CN': 'cn'
}
const tids = {
    en: '106',
    'zh-CN': '63'
}

const getLanguage = lang => {
    return languages[lang] || 'en'
}

/**
 * 获取浏览器的语言设置
 * 如果没找到则返回一个默认值 en
 */
export const getLang = () => {
    let lowerLang = (window.navigator.language ||
        window.navigator.browserLanguage ||
        'en').toLowerCase()

    // default: en
    return langs[lowerLang] || 'en'
}

/**
 * 设置 html 标签的 lang
 */
export const setHtmlLang = lang => {
        // documentElement 根root HTML
        document.documentElement.setAttribute('lang', lang)
    }
    //
    // export const getHomeswiperUrl = lang => {
    //   const language = getLanguage(lang)
    //   return `${BASEURI}/pic.php?type=%E9%A6%96%E9%A1%B5banner&num=4&language=${language}`
    // }
    //
    // export const getHomeswiperUrl2 = lang => {
    //   const language = getLanguage(lang)
    //   return `${BASEURI}/pic.php?type=%E6%89%8B%E6%9C%BA%E9%A6%96%E9%A1%B5banner&num=4&language=${language}`
    // }

export const getProductstypeUrl = lang => {
    const language = getLanguage(lang)
    const tid = tids[lang] || '106'
    return `${BASEURI}/productstype.php?language=${language}&tid=${tid}&num=100`
}

//获取首页的内容
export const getHomeInfo = () => {
        // const language = getLanguage(lang)
        return `${BASEURI}/getIndex.php`
    }
    //获取关于的内容
export const getAbout = () => {
        // const language = getLanguage(lang)
        return `${BASEURI}/getAbout.php`
    }
    //获取产品的内容
export const getProducts = (cid) => {
        // const language = getLanguage(lang)
        return `${BASEURI}/getProducts.php?cid=${cid}`
    }
    //获取更多Products的内容
export const moreProducts = (cid, num) => {
        // const language = getLanguage(lang)
        return `${BASEURI}/moreProducts.php?cid=${cid}&num=${num}`
    }
    //获取产品详情
export const getProductPage = (id) => {
    // const language = getLanguage(lang)
    return `${BASEURI}/getProductPage.php?id=${id}`
}

//获取解决方案的内容
export const getCases = (cid) => {
        // const language = getLanguage(lang)
        return `${BASEURI}/getCases.php?cid=${cid}`
    }
    //获取更多解决方案的内容
export const moreCases = (cid, num) => {
    // const language = getLanguage(lang)
    return `${BASEURI}/moreCases.php?cid=${cid}&num=${num}`
}

//获取解决方案详情
export const getCasePage = (id) => {
    // const language = getLanguage(lang)
    return `${BASEURI}/getCasePage.php?id=${id}`
}

//获取服务
export const getServices = (cid) => {
    // const language = getLanguage(lang)
    return `${BASEURI}/getServices.php?cid=${cid}`
}

//获取新闻列表
export const getNews = (cid) => {
        // const language = getLanguage(lang)
        return `${BASEURI}/getNews.php?cid=${cid}`
    }
    //获取更多新闻列表
export const moreNews = (cid, num) => {
        // const language = getLanguage(lang)
        return `${BASEURI}/moreNews.php?cid=${cid}&num=${num}`
    }
    //获取新闻详情
export const getNewsPage = (id) => {
    // const language = getLanguage(lang)
    return `${BASEURI}/getNewsPage.php?id=${id}`
}

//获取底部信息
export const getFooter = () => {
    // const language = getLanguage(lang)
    return `${BASEURI}/getFooter.php`
}